'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
  /*@ngInject*/
  function _class($http, $filter, JSONToCSVConvertor, ColorFinder, HourFinder) {
    _classCallCheck(this, _class);

    this.$http = $http;
    this.$filter = $filter;
    this.JSONToCSVConvertor = JSONToCSVConvertor;
    this.ColorFinder = ColorFinder;
    this.HourFinder = HourFinder;
    this.total = 0;
  }

  _createClass(_class, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.search = {
        colour: 'Dark Orange'
      };
      this.colours = ['Blue', 'Dark Blue', 'Striped Blue', 'Orange', 'Dark Orange', 'Striped Orange', 'Red', 'Dark Red', 'Striped Red', 'Purple', 'Dark Purple', 'Striped Purple', 'Grey', 'Dark Grey', 'Striped Grey', 'Green', 'Dark Green', 'Striped Green', 'Yellow', 'Dark Yellow', 'Striped Yellow', 'Lime', 'Dark Lime', 'Striped Lime'];
      this.$http.get('/api/lessons/').then(function (res) {
        _this.lessons = res.data;
      });

      this.$http.get('/api/students').then(function (response) {
        _this.students = response.data.filter(function (student) {
          return student.isActive;
        });
      });
    }
  }, {
    key: 'export',
    value: function _export(data) {
      data = data.map(function (entity) {
        var newObj = {};
        if (entity.student) {
          newObj.clientName = entity.student.firstName + ' ' + entity.student.lastName;
        } else {
          newObj.clientName = 'Hidden User';
        }
        newObj.found = entity.found;
        return newObj;
      });
      this.JSONToCSVConvertor(data, 'Tutor Export - ' + this.search.colour, true);
    }
  }, {
    key: 'processLessons',
    value: function processLessons() {
      var _this2 = this;

      var _search = this.search,
          colour = _search.colour,
          start = _search.start,
          end = _search.end;


      var temper = this.lessons.filter(function (lesson) {
        return !lesson.isHidden;
      });
      temper = temper.map(function (lesson) {
        return _this2.colourInstances(lesson, colour, start, end);
      });

      var temper2 = [];

      temper.forEach(function (lesson) {
        var foundEr = false;
        temper2.some(function (found, index) {
          if (found.clientUID === lesson.clientUID) {
            temper2[index].found += lesson.found;
            foundEr = true;
            return true;
          }
        });
        if (foundEr === false) {
          temper2.push(lesson);
        }
      });

      this.less = temper2.sort(function (a, b) {
        return a.found - b.found;
      });

      this.total = 0;
      this.less.forEach(function (lesson) {
        _this2.total += lesson.found;
      });
    }
  }, {
    key: 'colourInstances',
    value: function colourInstances(lesson, colour, start, end) {
      var msDay = 1000 * 60 * 60 * 24;
      colour = colour.toLowerCase();

      this.students.forEach(function (student) {
        if (lesson.clientUID == student._id) lesson.student = student;
      });

      lesson.newDate = this.$filter('reparseDate')(lesson.date);
      lesson.found = 0;

      if (lesson.newDate > end) {
        return lesson;
      }

      var maxPossible = Math.floor((end.getTime() - lesson.newDate.getTime()) / msDay / lesson.frequency) + 1;

      if (lesson.instances !== 0 && lesson.instances < maxPossible) {
        maxPossible = lesson.instances;
      }

      var startIndex = 0;
      if (start > lesson.newDate) {
        var dif = (start.getTime() - lesson.newDate.getTime()) / msDay;
        startIndex = Math.ceil(dif / lesson.frequency);
      }

      for (var i = startIndex; i < maxPossible; i++) {
        if (lesson.overwriteVisibility && lesson.overwriteVisibility[i] === true) {
          continue;
        }

        var lessonColor = this.ColorFinder(lesson, i);
        if (lessonColor === colour) {
          lesson.found += 1;
        }
      }

      return lesson;
    }
  }]);

  return _class;
}();

exports.default = _class;


// WEBPACK FOOTER //
// ./client/app/admin/colour-search/colour-search.controller.js